import { Box, Typography } from "@mui/material";

export interface ReviewDataPointProps {
  label: string;
  value: string;
  accent?: string;
  href?: string;
}

export const ReviewDataPoint = ({ label, value, accent, href }: ReviewDataPointProps) => (
  <Box sx={{ minWidth: 0 }}>
    <Typography
      sx={{
        color: "text.secondary",
        fontSize: "0.62rem",
        fontWeight: 700,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        mb: 0.35,
      }}
    >
      {label}
    </Typography>
    {href ? (
      <Typography
        component="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          display: "block",
          color: accent ?? "text.primary",
          fontSize: "0.86rem",
          fontWeight: 650,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          textDecoration: "none",
          "&:hover": { color: "primary.main", textDecoration: "underline" },
        }}
      >
        {value}
      </Typography>
    ) : (
      <Typography sx={{ color: accent ?? "text.primary", fontSize: "0.86rem", fontWeight: 650 }} noWrap>
        {value}
      </Typography>
    )}
  </Box>
);
